import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {useAppSelector} from "../store";

export interface IMenuInitialState
{
    show: boolean
}

const menuInitialState: IMenuInitialState = {
    show: false,
}

const slice = createSlice({
    name: 'menu',
    initialState: menuInitialState,
    reducers: {
        setShowMenu: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        toggleShowMenu: (state) => {
            state.show = !state.show;
        }
    }
})

export const menuReducer = slice.reducer;
export const { setShowMenu, toggleShowMenu } = slice.actions;
export const useMenuSelector = () => useAppSelector(state => state.menuReducer);

